(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvWorkflowResponseAddDocument', drvWorkflowResponseAddDocument);

    drvWorkflowResponseAddDocument.$inject = ['WorkflowRunService', 'DialogService'];
    
    function drvWorkflowResponseAddDocument(WorkflowRunService, DialogService) {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: true,
            templateUrl: 'app/workflow/responses/workflow-response-add-document.tmpl.html'
        };
        return directive;

        function link(scope, element, attrs) {
            scope.files = [];
            scope.uploadInProgress = false;
            scope.uploadComplete = false;

            scope.ok = function () {
                scope.uploadInProgress = true;

                WorkflowRunService.respondToStepWithFile(scope.instanceId, scope.step.StepId, scope.files[0].lfFile, 'file-name-goes-here').then(
                    function () {
                        scope.uploadInProgress = false;
                        scope.uploadComplete = true;
                    }, function (response) {
                        DialogService.error('Error uploading file', response);
                    });
            };
        }
    }
})();